import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NameAndCheck, NumberAndCheck } from '../../../../api/interfaces/user';
import { Condition, Antecedente } from '../../../../api/interfaces/register';
import { MobileDetectorService } from '../../../../services/mobileDetector/mobile-detector.service';
import { AntecedentesEnum } from 'src/app/enums/antecedentes';

@Component({
  selector: 'app-background',
  templateUrl: './background.component.html',
  styleUrls: ['./background.component.scss']
})
export class BackgroundComponent implements OnInit {

  backgrounds: NameAndCheck[] = [];
  days: NumberAndCheck[] = [
    {
    number: 0,
    check: false
    },
    {
      number: 1,
      check: false
    },
    {
      number: 2,
      check: false
    },
    {
      number: 3,
      check: false
    },
    {
      number: 4,
      check: false
    },
    {
      number: 5,
      check: false
    },{
      number: 6,
      check: false
    },
    {
      number: 7,
      check: false
    },
  ];

conditions: Condition[] = [
  {name:"Muy malo", selected: false, index: 0},
  {name:"Malo", selected: false, index: 1},
  {name:"Regular", selected: false, index: 2},
  {name:"Bueno", selected: false, index: 3},
  {name:"Muy bueno", selected: false, index: 4}
];

  showObjetives: boolean = false;
  showComplements: boolean = false;
  isMobile: boolean = false;
  disable: boolean = true;

  complements: string[] = [];

  @Input('antecedente') antecedente:  Antecedente[];

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private mobileDetectorService: MobileDetectorService,
  ) { }

  backgroundForm = new FormGroup({
    background: new FormControl(),
    days: new FormControl(),
    trainingWeek: new FormControl(),
    condition: new FormControl(),
    complement: new FormControl(),
    restAndFood: new FormControl(),
    shoes: new FormControl()
  });

  ngOnInit(): void {
    this.isMobile = this.mobileDetectorService.isMobile();

    this.getAnswersQuestionFive();
    this.patchValues();
  }

  getAnswersQuestionFive() {
    this.translate
            .get([
              'registration.stepThree.genericAnswers.yes',
              'registration.stepThree.genericAnswers.no',
            ])
            .subscribe(translations => {
                this.complements.push(translations['registration.stepThree.genericAnswers.yes']);
                this.complements.push(translations['registration.stepThree.genericAnswers.no']);
            });
  }

  getAnswersQuestionOne() {
    let aux : NameAndCheck = {
      name: "",
      check: false
    }
    this.translate
            .get([
              'registration.stepThree.question1.answer1',
              'registration.stepThree.question1.answer2',
              'registration.stepThree.question1.answer3',
              'registration.stepThree.question1.answer4',
            ])
            .subscribe(translations => {
                this.backgrounds.push({name: translations['registration.stepThree.question1.answer1'],check: this.loadingCheck(translations['registration.stepThree.question1.answer1'])});
                this.backgrounds.push({name:translations['registration.stepThree.question1.answer2'],check: this.loadingCheck(translations['registration.stepThree.question1.answer2'])});
                this.backgrounds.push({name:translations['registration.stepThree.question1.answer3'],check: this.loadingCheck(translations['registration.stepThree.question1.answer3'])});
                this.backgrounds.push({name:translations['registration.stepThree.question1.answer4'],check: this.loadingCheck(translations['registration.stepThree.question1.answer4'])});
            });
  }

  loadingCheck(name: string) {
    let response: boolean = false;
    if(name === this.backgroundForm.value.background) {
      response = true;
    }
    return response;
  }

  checkDays() {
    this.days.forEach(day => {
      if(day.number == this.backgroundForm.value.days) {
        day.check = true;
      }
    })
  }

  edit() {
    this.disable = !this.disable;
  }

  onSubmit() {
    this.edit();
    //api call
  }

  changeComplements(mode: boolean) {
    if(!this.disable) {
      this.showComplements = mode;
      if(!mode) {
        this.backgroundForm.value.complement = null;
      }
    }
  }

  patchValues() {
    let found: number;

    found = this.antecedente.findIndex(element => element.antecedentePreguntaId == AntecedentesEnum.CALZ);
    this.backgroundForm.patchValue({shoes: this.antecedente[found].antecedenteRespuesta});

    found = this.antecedente.findIndex(element => element.antecedentePreguntaId == AntecedentesEnum.DYA);
    this.backgroundForm.patchValue({restAndFood: this.antecedente[found].antecedenteRespuesta});
    
    found = this.antecedente.findIndex(element => element.antecedentePreguntaId == AntecedentesEnum.SEM);
    this.backgroundForm.patchValue({trainingWeek: this.antecedente[found].antecedenteRespuesta});

    found = this.antecedente.findIndex(element => element.antecedentePreguntaId == AntecedentesEnum.FREQ)
    this.backgroundForm.patchValue({days: this.antecedente[found].antecedenteRespuesta});
    this.checkDays();

    found = this.antecedente.findIndex(element => element.antecedentePreguntaId == AntecedentesEnum.EXP)
    this.backgroundForm.patchValue({background: this.antecedente[found].antecedenteRespuesta});
    this.getAnswersQuestionOne();

    found = this.antecedente.findIndex(element => element.antecedentePreguntaId == AntecedentesEnum.COMP)
    this.backgroundForm.patchValue({complement: this.antecedente[found].antecedenteRespuesta});
    if(this.antecedente[found].antecedenteRespuesta != "No") {
      this.showComplements = true;
    }

    found = this.antecedente.findIndex(element => element.antecedentePreguntaId == AntecedentesEnum.EST)
    this.backgroundForm.patchValue({condition: this.antecedente[found].antecedenteRespuesta});
    let index: number = this.conditions.findIndex(condition => condition.name == this.backgroundForm.value.condition);
    this.conditions[index].selected = true;
  }


}
